import angular from 'angular'
import baseTemplate from 'views/common/template.html'
import index from './view/normalIndex.html'
import indexCtrl from './indexCtrl.js'

export default angular
    .module('index', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('index', {
            abstract: true,
            url: '/index',
            template: baseTemplate,
        }),
        $stateProvider.state('index.list', {
            url: '/index/list',
            template: index,
            controller: 'indexCtrl',
            title: '首页',
        })
    }])
    .controller('indexCtrl', indexCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/index/index.js